import React from 'react';
import Icon from 'Components/Icon';
import { Button } from 'Components/nui';
import { useStoreState } from 'easy-peasy';
import * as R from 'ramda';
import { FormattedMessage } from 'react-intl';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

const DropdownPanel = () => {
  const solutionColumns = useStoreState((state) => state.auth.solutionColumns);
  const solutionSettings = useStoreState(
    (state) => state.auth.solutionSettings
  );

  const canCounter =
    R.pathOr(true, ['counterbids'], solutionSettings) ||
    R.pathOr(true, ['counteroffers'], solutionSettings);

  const canPrivate = !!solutionColumns.counterparty;

  return (
    <div className="tw mpkey">
      <div className="tw:p-3 mpkey-panel">
        <h2>
          <FormattedMessage
            id="marketplace-legend-heading"
            description="Heading for marketplace legend in Marketplace"
            defaultMessage="What's what"
          />
        </h2>
        <div className="tw:text-sm tw:mb-2">
          <FormattedMessage
            id="marketplace-legend-helptext"
            description="Helptext for marketplace legend in Marketplace"
            defaultMessage="A visual guide to help you navigate around"
          />
        </div>

        <ul className="tw:m-0">
          <li>
            <span className="mp-help-icon has-qa">Q&amp;A</span>
            <FormattedMessage
              id="marketplace-legend-qa-text"
              description="text for qa icon in marketplace legend in Marketplace"
              defaultMessage="Includes questions from users"
            />
          </li>
          <li>
            <em className="mp-help-icon icon-comment has-comment"></em>
            <FormattedMessage
              id="marketplace-legend-comment-text"
              description="text for comment icon in marketplace legend in Marketplace"
              defaultMessage="Includes additional comments"
            />
          </li>
          {R.path(['attachments', 'type'], solutionColumns) === 'file' && (
            <li>
              <em className="mp-help-icon icon-attach-circled is-bundle"></em>
              <FormattedMessage
                id="marketplace-legend-attachments-text"
                description="text for attatchements icon in marketplace legend in Marketplace"
                defaultMessage="This order has attachments"
              />
            </li>
          )}
          {canCounter && (
            <>
              <li>
                <span className="mp-help-icon has-counters">2</span>
                <FormattedMessage
                  id="marketplace-legend-counter-text"
                  description="text for counter orders icon in marketplace legend in Marketplace"
                  defaultMessage="There are counter orders"
                />
              </li>
              <li>
                <span className="mp-help-icon has-counters">
                  <span className="my-counter"></span>2
                </span>
                <FormattedMessage
                  id="marketplace-legend-my-counter-text"
                  description="text for my-counter icon in marketplace legend in Marketplace"
                  defaultMessage="You placed your counter order"
                />
              </li>
            </>
          )}
          {canPrivate && (
            <>
              <li>
                <Icon
                  name="lock_person"
                  size="small"
                  className="tw:absolute tw:left-[6px] tw:top-[3px] tw:text-gray-500"
                />
                <FormattedMessage
                  id="marketplace-legend-private-order-text"
                  description="text for private-order icon in marketplace legend in Marketplace"
                  defaultMessage="Private offer/bid"
                />
              </li>
              <li>
                <Icon
                  name="lock"
                  size="small"
                  className="tw:absolute tw:left-[6px] tw:top-[3px] tw:text-gray-500"
                />
                <FormattedMessage
                  id="marketplace-legend-private-group-order-text"
                  description="text for private-group-order icon in marketplace legend in Marketplace"
                  defaultMessage="Private group offer/bid"
                />
              </li>
            </>
          )}
        </ul>
      </div>
    </div>
  );
};

export default () => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          type="primary"
          className="icon-help show-mpkey-panel tw:rounded-full tw:w-6 tw:h-6 tw:p-0 tw:flex tw:items-center tw:justify-center"
        >
          &#65279;
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="tw:w-auto tw:p-0">
        <DropdownPanel />
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
